"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M14.5 20a1 1 0 01-1 1h-3a1 1 0 01-1-1v-6H6.236a.5.5 0 01-.348-.86l5.747-5.56a.5.5 0 01.694-.002l5.777 5.562a.5.5 0 01-.347.86H14.5v6zM4 5h16V3H4v2z" }), "Upload");
//# sourceMappingURL=Upload.js.map